import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import {
  Alert,
  Button,
  Modal,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  Checkbox,
} from "CommonComponents/bricks";

@store("currentMassnahmeInflight")
export default class AntragEinreichenPopup extends Component {
  constructor() {
    super();
    this.state = {
      anzahl: 0,
      checksOk: false,
      checks: [
        { text: "Ich versichere die Richtigkeit der von mir gemachten Angaben, insbesondere hinsichtlich der Staatsangehörigkeit" },
        {
          text: "Ich verpflichte mich, Änderungen des Familienstandes, der Bankverbindung, des Studienplatzes, der Aufnahme einer Nebentätigkeit" +
            " sowie insbesondere den Abschluss des Hochschulstudiums unverzüglich und unaufgefordert dem Personaldezernat anzuzeigen",
        },
        {
          text: "Ich wurde davon in Kenntnis gesetzt, dass die geforderten Unterlagen benötigt werden und eine möglichst reibungslose Abwicklung" +
            " der Lohnzahlungen nur gewährleistet werden kann, wenn die Anträge einschließlich aller nötigen Anlagen mindestens 2 Wochen vor" +
            " Vertragsbeginn im Personaldezernat vorliegen",
        },
        {
          text: "Ich wurde darüber informiert, dass ich die Arbeit erst aufnehmen darf, wenn ich den von den Mitarbeiter*innen des Personaldezernat unterschriebenen Arbeitsvertrag erhalten habe.",
        },
        {
          text: "Das von den Verantwortungsträgern innerhalb der Hochschule besondere Beschäftigungsbeschränkungen und -verbote - insbesondere bei" +
            " bestehender Schwangerschaft - nach dem Mutterschutzgesetz zu beachten sind, habe ich zur Kenntnis genommen. Hierzu ist die unverzügliche" +
            " Anzeige über eine bestehende Schwangerschaft an das Personaldezernat Abwesenheitsangelegenheiten der Hochschulverwaltung notwendig",
        },
      ],

      checksWerkvertrag: [
        { text: "Ich versichere die Richtigkeit der von mir gemachten Angaben." },
        {
          text: "Mir ist bewusst, dass die geforderten Unterlagen benötigt werden, und dass eine möglichst reibungslose Abwicklung" +
            " aller Vertragsangelegenheiten inklusive der Bezahlung meiner Leistung nur gewährleistet werden können," +
            " wenn die Anträge einschließlich aller Unterlagen mindestens vier Wochen vor dem geplanten Vertragsbeginn im Dezernat 1 vorliegen.",
        },
        {
          text: "Mir ist bewusst, dass ich die Erstellung der Leistung erst dann beginnen darf, wenn ich den seitens der" +
            "  Bergischen Universität Wuppertal unterschriebenen Werkvertrag erhalten habe.",
        },
      ],

      checksLehrauftrag: [
        { text: "Ich versichere die Richtigkeit der von mir gemachten Angaben, insbesondere hinsichtlich der Staatsangehörigkeit." },
        { text: "Ich verpflichte mich, Änderungen der Bankverbindung und Anschrift unverzüglich und unaufgefordert dem Personaldezernat Hilfskräfte und Lehraufträge anzuzeigen." },
        {
          text: "Ich wurde darüber unterrichtet, dass ich die Arbeit erst aufnehmen darf, wenn ich die vom Personaldezernat Hilfskräfte und Lehraufträge" +
            " unterschriebene Beauftragung erhalten habe.",
        },
        { text: "Die Verpflichtungserklärung zur Einhaltung der datenschutzrechtlichen Anforderungen, die ich zusammen mit der Beauftragung erhalten werde, werde ich vor Beginn meiner Lehrtätigkeit unterschrieben an Personaldezernat Hilfskräfte und Lehraufträge senden." },
      ],

      checksVortrag: [
        { text: "Ich versichere die Richtigkeit der von mir gemachten Angaben, insbesondere hinsichtlich der Nicht-Selbständigkeit." },
      ],

      checksTarifvertrag: [
        {
          text: "Bitte beachten Sie, dass es sich um einen Antrag handelt. Ein Beschäftigungsverhältnis wird erst dann begründet, wenn ein entsprechender Arbeitsvertrag zwischen Ihnen als einzustellender Person und der Personalabteilung abgeschlossen ist. Bis zu diesem Zeitpunkt dürfen keine Arbeitsleistungen erbracht oder angenommen werden.",
        },
        { text: "Ich versichere die Richtigkeit der von mir gemachten Angaben, insbesondere hinsichtlich der Staatsangehörigkeit." },
        {
          text: "Ich verpflichte mich, Änderungen des Familienstandes, der Anschrift, der Bankverbindung oder die Aufnahme einer Nebentätigkeit unverzüglich und unaufgefordert dem Personaldezernat anzuzeigen.",
        },
        {
          text: "Ich wurde davon in Kenntnis gesetzt, dass die geforderten und von mir unterschriebenen Unterlagen benötigt werden und eine möglichst reibungslose Abwicklung" +
            " der Lohnzahlungen nur gewährleistet werden kann, wenn die Anträge einschließlich aller nötigen Anlagen mindestens 2 Wochen vor" +
            " Vertragsbeginn im Personaldezernat vorliegen.",
        },
        {
          text: "Dass von den Verantwortungsträgern innerhalb der Hochschule besondere Beschäftigungsbeschränkungen und -verbote - insbesondere bei" +
            " bestehender Schwangerschaft - nach dem Mutterschutzgesetz zu beachten sind, habe ich zur Kenntnis genommen. Hierzu ist die unverzügliche" +
            " Anzeige über eine bestehende Schwangerschaft an das Personaldezernat Abwesenheitsangelegenheiten der Hochschulverwaltung notwendig.",
        },
      ],
    };
  }

  getChecks = () => {
    // Checks passend zum Modus liefern
    const { modus } = this.props;
    if (modus.istVortrag) {
      return this.state.checksVortrag;
    } else if (modus.istWerkvertrag) {
      return this.state.checksWerkvertrag;
    } else if (modus.istLehrauftrag) {
      return this.state.checksLehrauftrag;
    } else if (modus.istTarifvertrag) {
      return this.state.checksTarifvertrag;
    }
    return this.state.checks;
  };

  render() {
    const { onCancel, modus } = this.props;
    const { errorMessage } = this.state;

    return (

      <Modal show onHide={onCancel}>
        <Modal.Header>
          Antrag einreichen
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}

          <h3>Der Antrag ist vollständig und kann fristgerecht eingereicht werden</h3>

          {modus.istWerkvertrag && <p>Wenn Sie anderweitig beschäftigt sind oder erwerbslos oder Rentnerin bzw. Rentner, dann denken Sie bitte daran, dass Sie die hier beantragte Tätigkeit im Rahmen des Werkvertrags Ihrem Leistungserbringer oder Arbeitgeber gegenüber anzeigen! <br /><br /> </p>}

          <p>Bitte bestätigen Sie die folgenden Hinweise, bevor Sie den Antrag einreichen.</p>

          {_.map(this.getChecks(), (check, idx) => <Checkbox key={idx} label={check.text} onChange={this.onChange} />)}

        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={this.onConfirm} disabled={!this.state.checksOk}>
            Antrag einreichen
          </Button>
          <Button variant='link' onClick={this.onCancel}>Abbrechen</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  onChange = e => {
    const { anzahl } = this.state;
    const { checked } = e.target;
    const anz = checked ? anzahl + 1 : anzahl - 1;
    this.setState({ anzahl: anz, checksOk: this.getChecks().length == anz });
  };

  onConfirm = async() => {
    const { a_id } = this.props;
    try {
      await apifetch("/api/shkantrag/massnahmevorgesehen/einreichen", {
        method: "POST",
        body: { a_id: a_id },
      });
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
      return false;
    }
    this.props.onClose();
  };
  onCancel = () => {
    this.props.onCancel();
  };
}
